import styled from '@emotion/styled';
import { ButtonEmotion } from '@utex/ui-kit';

export const Container = styled('div')`
  padding-top: 1.6rem;
  padding-left: 2.4rem;
  padding-right: 2.4rem;

  ${ButtonEmotion} {
    min-height: 3.6rem;
    height: 3.6rem;
    padding-left: 1.4rem;
    padding-right: 1.4rem;
  }
`;
